angular
    .module("ainapp")
    .controller("generalLedger2Controller", [
    "app.config",
    "$scope",
    "$http",
    "AuthenticationService",
    "$state",
    "$stateParams",
    "MainService",
    "localStorageService",
    "$window",
    function (
            config,
            $scope,
            $http,
            AuthenticationService,
            $state,
            $stateParams,
            MainService,
            localStorageService,
            $window
        ) {},
  ]);

angular.module("ainapp").controller("generalLedgerController", [
  "app.config",
  "$scope",
  "$http",
  "AuthenticationService",
  "$state",
  "$stateParams",
  "MainService",
  "localStorageService",
  "$window",
  function (
        config,
        $scope,
        $http,
        AuthenticationService,
        $state,
        $stateParams,
        MainService,
        localStorageService,
        $window
    ) {
        $scope.init = function () {
            $scope.selectAllAccRows = false;
            $scope.Load = false;
            $scope.Error = 0;
            $scope.FromDateObject = null;
            $scope.ToDateObject = null;

            $scope.date1 = new Date();
            var n = $scope.date1.getFullYear();
            $scope.d2 = new Date("01/01/" + n);

            $scope.filter = {
                AccountMasterId: "",
                FromDate: $scope.d2,
                ToDate: new Date(),
                IsFilter: false,
                DocNo: "",
                CostCenter1Id: "",
                CostCenter2Id: "",
                CostCenter3Id: "",
            };

            $scope.finyear = {};
            MainService.getCurrentFinancialYear().then(function (response) {
                $scope.finyear = response.data;
                $scope.filter.FromDate = new Date($scope.finyear.StartDate);

                if($stateParams.accId > 0){
                     $scope.filter.IsFilter = true;
                     $("#gl-master-grid").data("kendoGrid").dataSource.read();

                     let [day, month, year] = $stateParams.datefrom.split("/").map(Number);
                     let frdate = new Date(year, month - 1, day);
                    $scope.filter.FromDate = frdate;

                       let [day2, month2, year2] = $stateParams.dateTo.split("/").map(Number);
                     let frdate2 = new Date(year2, month2 - 1, day2);
                    $scope.filter.ToDate = frdate2;

                }else{
                    $scope.initGeneralLedgerFilterState(); // Initialize React filter state
                    $scope.FilterData();
                }

                


            });

            $scope.AccFilter = {
                Keyword: "",
            };
            $scope.selectAll = false;

            $scope.GlLoad = false;
            $scope.AccLoad = true;
            $scope.Accounts = [];
            MainService.AccountList().then(function (response) {
                $scope.Accounts = response.data;
                $scope.AccLoad = false;
            });

            $scope.SelectedAccounts = [];
            $scope.GlData = [];

            // $('#filtermodal').modal('show');

            $scope.IsHideCost = false;
        };

        // Add after existing $scope.init = function() { ... }
        $scope.initGeneralLedgerFilterState = function () {
            // Set default to "This Month" instead of financial year dates
            const now = new Date();
            const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
            const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

            $scope.generalLedgerFilterState = {
                accountIds: [],
                fromDate: monthStart,
                toDate: monthEnd,
                docNo: $scope.filter.DocNo || "",
                // Store last selected state for modal reopening
                lastSelectedAccountIds: [],
            };
        };

        // Replace existing $scope.FilterData function
        $scope.FilterData = function () {
            // Check if React plugin is available
            if (
                !window.AppReactLib ||
                !window.AppReactLib.generalLedgerFilter.RenderGeneralLedgerFilterModal
            ) {
                console.warn(
                    "React GeneralLedgerFilter plugin not available, falling back to Angular modal"
                );
                $("#filtermodal").modal("show");
                return;
            }

            try {
                // Prepare date strings for React (ISO format)
                const fromDateString = $scope.generalLedgerFilterState.fromDate ?
                    $scope.generalLedgerFilterState.fromDate.toISOString() :
                    $scope.filter.FromDate.toISOString();

                const toDateString = $scope.generalLedgerFilterState.toDate ?
                    $scope.generalLedgerFilterState.toDate.toISOString() :
                    $scope.filter.ToDate.toISOString();

                window.AppReactLib.generalLedgerFilter.RenderGeneralLedgerFilterModal({
                    // Pass current filter state as props
                    selectedAccountIds: $scope.generalLedgerFilterState.lastSelectedAccountIds || [],
                    fromDate: fromDateString,
                    toDate: toDateString,
                    docNo: $scope.generalLedgerFilterState.docNo,

                    // Financial year context for date validation
                    financialYear: {
                        startDate: $scope.finyear.StartDate,
                        endDate: $scope.finyear.EndDate || new Date().toISOString(),
                    },

                    onApply: function (result) {
                        console.log("result", result);
                        // Use $evalAsync to avoid digest conflicts
                        $scope.$evalAsync(function () {
                            try {
                                // Convert dates back to JS Date objects
                                const fromDate = result.fromDate ?
                                    new Date(result.fromDate) :
                                    $scope.filter.FromDate;
                                const toDate = result.toDate ?
                                    new Date(result.toDate) :
                                    $scope.filter.ToDate;

                                // Update filter state for next modal opening
                                $scope.generalLedgerFilterState = {
                                    accountIds: result.accountIds || [],
                                    fromDate: fromDate,
                                    toDate: toDate,
                                    docNo: result.docNo || "",
                                    lastSelectedAccountIds: result.accountIds || [],
                                };

                                // Update the existing filter object (maintain compatibility)
                                $scope.filter.Accounts = result.accountIds || [];
                                $scope.filter.FromDate = fromDate;
                                $scope.filter.ToDate = toDate;
                                $scope.filter.DocNo = result.docNo || "";
                                $scope.filter.IsFilter = true;
                                console.log("filter", $scope.filter);
                                console.log(
                                    "generalLedgerFilterState",
                                    $scope.generalLedgerFilterState
                                );
                                // Refresh grid using existing logic
                                $("#gl-master-grid").data("kendoGrid").dataSource.read();

                                console.log("Filter applied successfully:", $scope.filter);
                            } catch (error) {
                                console.error("Error applying filter:", error);
                                toastr.error("Error applying filter");
                            }
                        });
                    },

                    onReset: function () {
                        $scope.$evalAsync(function () {
                            try {
                                // Reset filter state to "This Month" (consistent with initial state)
                                const now = new Date();
                                const monthStart = new Date(
                                    now.getFullYear(),
                                    now.getMonth(),
                                    1
                                );
                                const monthEnd = new Date(
                                    now.getFullYear(),
                                    now.getMonth() + 1,
                                    0
                                );

                                $scope.generalLedgerFilterState = {
                                    accountIds: [],
                                    fromDate: monthStart,
                                    toDate: monthEnd,
                                    docNo: "",
                                    lastSelectedAccountIds: [],
                                };

                                // Use existing reset logic
                                $scope.Reset();

                                console.log("Filter reset successfully");
                            } catch (error) {
                                console.error("Error resetting filter:", error);
                                toastr.error("Error resetting filter");
                            }
                        });
                    },

                    onClose: function () {
                        // Modal handles its own closing
                        console.log("Filter modal closed");
                    },
                });
            } catch (error) {
                console.error("Failed to open React filter modal:", error);
                toastr.error("Failed to open filter. Using fallback modal.");
                // Fallback to existing Angular modal
                $("#filtermodal").modal("show");
            }
        };
        $scope.init();

        $scope.PageName = "General Ledger";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.treelistOptions = {
            dataSource: {
                transport: {
                    read: function (o) {
                        MainService.AccountsInKendoTree().then(
                            function (response) {
                                o.success(response.data);
                            },
                            function (err) {
                                o.success([]);
                                toastr.error("NetworkError");
                            }
                        );
                    },
                },
                schema: {
                    model: {
                        id: "Id",
                        parentId: "ParentId",
                        fields: {
                            ParentId: {
                                field: "ParentId",
                                nullable: true,
                            },
                            Name: {
                                field: "Name",
                                type: "string",
                            },
                            AccountCode: {
                                field: "AccountCode",
                                type: "string",
                            },
                            "AccountType.Name": {
                                //field: "AccountCode",
                                type: "string",
                            },
                        },
                        expanded: true,
                    },
                },
                serverFiltering: false,
            },

            editable: false,
            height: 400,
            sortable: true,
            filterable: {
                mode: "row",
            },
            pageable: {
                pageSize: 50,
                pageSizes: true,
            },
            columns: [
                {
                    field: "AccountCode",
                    title: "Account Code",
        },
                {
                    field: "Name",
                    title: "Name",
        },
                {
                    field: "AccountType.Name",
                    title: "Account Type",
        },
                {
                    headerTemplate: "<input  style='margin-left:5px'  type='checkbox' ng-model='selectAllAccRows' ng-click='selectAllAccounts(this)'/>",
                    template: "<input style='margin-left:10px' type='checkbox'  kendo-select={{dataItem.selected}} ng-model='dataItem.checked' ng-change='selectAccountsHead(dataItem)' />",
                    width: "40px",
        },
      ],
        };

        $scope.selectAllAccounts = function (ele) {
            $scope.selectAllAccRows = !$scope.selectAllAccRows;
            if ($scope.selectAllAccRows) {
                angular.forEach($scope.ktl.dataSource.data(), function (row) {
                    row.checked = true;
                });
            } else {
                angular.forEach($scope.ktl.dataSource.data(), function (row) {
                    row.checked = false;
                });
            }
            var grid = $scope.ktl;
            if ($scope.selectAllAccRows) {
                grid.table.find("tr").addClass("k-state-selected");
            } else {
                grid.table.find("tr").removeClass("k-state-selected");
            }
        };

        $scope.selectAccountsHead = function (data) {
            //data.checked = !data.checked;
            var rows = $scope.ktl.dataSource.data();
            var tt = data.checked;
            if (tt) {
                angular.forEach(rows, function (e) {
                    if (e.ParentId == data.Id) {
                        e.checked = true;
                        $scope.selectAccountsHead(e);
                    }
                });
            } else {
                angular.forEach(rows, function (e) {
                    if (e.ParentId == data.Id) {
                        e.checked = false;
                        $scope.selectAccountsHead(e);
                    }
                });
            }
        };

        $scope.searchAcc = function () {
            $scope.ktl.options.dataSource.schema.model.expanded = true;
            $scope.ktl.dataSource.filter({
                field: "Name",
                operator: "contains",
                value: $scope.AccFilter.Keyword,
            });
            $scope.ktl.dataSource.read();
        };

        $scope.resetAcc = function () {
            $scope.ktl.dataSource.filter({});
            $scope.ktl.options.dataSource.schema.model.expanded = false;
            $scope.ktl.setDataSource($scope.ktl.options.dataSource);
        };

        $scope.Filter = function () {
            $scope.filter.Accounts = $scope.SelectedAccounts;
            $scope.filter.IsFilter = true;
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
            $("#filtermodal").modal("hide");
        };

        // Enhance existing Reset function to handle React filter state
        $scope.Reset = function () {
            // Call existing reset logic first
            $scope.init();

            // Reset React filter state to "This Month" (consistent with initial state)
            if ($scope.generalLedgerFilterState) {
                const now = new Date();
                const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                $scope.generalLedgerFilterState = {
                    accountIds: [],
                    fromDate: monthStart,
                    toDate: monthEnd,
                    docNo: "",
                    lastSelectedAccountIds: [],
                };
            }

            // Refresh grid
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
        };

        // Debug function for testing React plugin availability
        $scope.debugFilterState = function () {
            console.log("Current filter state:", {
                filter: $scope.filter,
                reactFilterState: $scope.generalLedgerFilterState,
                financialYear: $scope.finyear,
                reactPluginAvailable: !!(
                    window.AppReactLib &&
                    window.AppReactLib.generalLedgerFilter.RenderGeneralLedgerFilterModal
                ),
            });
        };

        $scope.totalBalance = "0";
        $scope.glGridDataSource = new kendo.data.DataSource({
            page: 1,
            pageSize: 100,
            transport: {
                read: function (o) {
                    $scope.totalBalance = "0";
                    if ($scope.filter != null && $scope.filter != undefined) {
                        o.data.IsFilter = $scope.filter.IsFilter;
                        o.data.FromDate = $scope.filter.FromDate;
                        o.data.ToDate = $scope.filter.ToDate;
                        o.data.DocNo = $scope.filter.DocNo;

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();

                        if ($scope.filter.IsFilter == true) {

                            if($stateParams.accId > 0){
                                o.data.IsDirectLedger = true;
                                o.data.Accounts = [];
                                o.data.Accounts.push($stateParams.accId);

                                let [day, month, year] = $stateParams.datefrom.split("/").map(Number);

                                o.data.FromMonth = month;
                                o.data.FromDay = day;
                                o.data.FromYear = year;

                                let [day2, month2, year2] = $stateParams.dateTo.split("/").map(Number);

                                o.data.ToMonth = month2;
                                o.data.ToDay = day2;
                                o.data.ToYear = year2;

                            }else{
                                o.data.Accounts = $scope.generalLedgerFilterState.accountIds;
                            }
                           
                            var data = JSON.stringify(o.data);

                            $http.post(config.basePath + "GLInView", data).then(
                                function (response) {
                                    var data = {
                                        Data: response.data.Data,
                                        Total: response.data.Total,
                                        TotalBalance: response.data.TotalBalance,
                                    };
                                    $scope.GlData = response.data.Data;
                                    $scope.totalBalance = kendo.toString(
                                        response.data.TotalBalance,
                                        "0.00"
                                    );
                                    o.success(data);
                                },
                                function (err) {
                                    o.success({
                                        Data: [],
                                    });
                                    toastr.error("Some Error Occured");
                                }
                            );
                        } else {
                            o.success({
                                Data: [],
                            });
                        }
                    } else {
                        o.success({
                            Data: [],
                        });
                    }
                },
            },
            schema: {
                data: "Data",
                total: "Total",
                model: {
                    id: "Id",
                    fields: {
                        "Account.Name": {
                            type: "string",
                        },
                        "RefAccount.Name": {
                            type: "string",
                        },
                        AccountId: {
                            type: "number",
                        },
                        Remarks: {
                            type: "string",
                        },
                        PDCType: {
                            type: "string",
                        },
                        Type: {
                            type: "string",
                        },
                        Debit: {
                            type: "number",
                        },
                        Credit: {
                            type: "number",
                        },
                        BalanceAmount: {
                            type: "number",
                            cellFilter: "number: 2",
                        },
                        Date: {
                            type: "date",
                        },
                        VoucherNumber: {
                            type: "string",
                        },
                    },
                },
            },
            group: [
                {
                    field: "Account.Name",
                    aggregates: [
                        {
                            field: "Debit",
                            aggregate: "sum",
            },
                        {
                            field: "Credit",
                            aggregate: "sum",
            },
          ],
        },
      ],
            aggregate: [
                {
                    field: "Debit",
                    aggregate: "sum",
        },
                {
                    field: "Credit",
                    aggregate: "sum",
        },
      ],
            serverPaging: false,
            serverSorting: false,
            serverFiltering: false,
        });
        $scope.glGridOptions = {
            stretch: true,
            toolbar: ["excel"],
            excel: {
                allPages: true, // Export all data
                //                fileName: "KendoGridData.xlsx"
            },
            selectable: true,
            editable: false,
            pageable: true,
            height: 780,
            resizable: true,
            dataSource: $scope.glGridDataSource,
            pageSize: 100,
            pageable: {
                input: false,
                refresh: true,
                pageSizes: true,
                info: true,
            },
            sortable: true,
            scrollable: {
                virtual: true,
            },
            filterable: true,
            groupable: false,
            columnMenu: {
                filterable: false,
                filterable: true,
            },
            dataBound: onDataBound,

            columns: [
                {
                    field: "Account.Name",
                    hidden: true,
                    //groupHeaderTemplate: "Account : #= value # ",
                    groupHeaderTemplate: function (data) {
                        var first = data.items[0];
                        var previousBalance =
                            first.BalanceAmount + first.Credit - first.Debit;

                        return (
                            "Account: " +
                            data.value +
                            " - Previous Balance: " +
                            kendo.toString(previousBalance, "0.00")
                        );
                    },
        },
                {
                    field: "PDCType",
                    hidden: true,
                    groupHeaderTemplate: " #= value # ",
        },
                {
                    field: "Date",
                    title: "Date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    headerTemplate: "{{LanguageData.date}}",
        },
                {
                    field: "VoucherNumber",
                    title: "Voucher #",
                    headerTemplate: "{{LanguageData.voucher}}",
        },
                {
                    field: "Type",
                    title: "Type",
                    width: "200px",
                    headerTemplate: "{{LanguageData.type}}",
        },
                {
                    field: "RefAccount.Name",
                    title: "Account",
                    width: "200px",
        },
                {
                    field: "Remarks",
                    title: "Remarks",
                    width: "300px",
                    headerTemplate: "{{LanguageData.remarks}}",
        },
                {
                    field: "Debit",
                    title: "Debit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Debit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "Debit: #=kendo.toString(sum, 'n')#",
                    headerTemplate: "{{LanguageData.debit}}",
        },
                {
                    field: "Credit",
                    title: "Credit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Credit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "Credit: #=kendo.toString(sum, 'n')#",
                    headerTemplate: "{{LanguageData.credit}}",
        },
                {
                    field: "BalanceAmount",
                    title: "Balance",
                    template: "<div style='text-align: right'>#=kendo.toString(BalanceAmount, 'n')#</div>",
                    //groupFooterTemplate: "Balance: #=kendo.toString(sum, '0.00')#",
                    groupFooterTemplate: function (data) {
                        //                        console.log("groupFooterTemplate", data)
                        var items = data.group ? data.group.items : data.items;
                        if (items && items.length > 0) {
                            return (
                                "Balance: " +
                                kendo.toString(items[items.length - 1].BalanceAmount, "0.00")
                            );
                        }
                        return "";
                    },
                    //                                        footerTemplate: "Balance: {{totalBalance}}",
                    footerTemplate: function (data) {
                        return "Balance: " + $scope.totalBalance;
                    },
                    headerTemplate: "{{LanguageData.balance}}",
        },
      ],
        };

        function customFooter(data) {
            console.log(data);
            return 1;
        }

        function onDataBound() {
            var grid = this;
            // grid.element.on("dblclick", "tbody tr[data-uid]", function (e) {
            //     grid = $("#gl-master-grid").data("kendoGrid");
            //     var selectedData = grid.dataItem(grid.select());
            //     $scope.goLegerVoucher(selectedData);
            // }); 
            grid.element
        .off("dblclick", "tbody tr[data-uid]") // Remove any existing dblclick handlers
        .on("dblclick", "tbody tr[data-uid]", function (e) {
            grid = $("#gl-master-grid").data("kendoGrid");
            var selectedData = grid.dataItem($(this));
            $scope.goLegerVoucher(selectedData);
        });
        }

        $scope.printLedger = function () {
            $scope.filter.IsFilter = $scope.filter.IsFilter;
            $scope.filter.FromDate = $scope.filter.FromDate;
            $scope.filter.ToDate = $scope.filter.ToDate;
            $scope.filter.DocNo = $scope.filter.DocNo;

            $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            $scope.filter.FromDay = $scope.filter.FromDate.getDate();
            $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

            $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            $scope.filter.ToDay = $scope.filter.ToDate.getDate();
            $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

            var accList = $.grep($scope.ktl.dataSource.data(), function (e) {
                return e.checked;
            });

            var accIds = [];
            angular.forEach(accList, function (e) {
                if (e.IsGroup == false) {
                    accIds.push(e.Id);
                }
            });

            console.log(accIds);

            $scope.filter.Accounts = accIds;

            $.LoadingOverlay("show", {
                image: "images/load.gif",
            });

            MainService.PrintGeneralLedgerReport($scope.filter).then(
                function (response) {
                    if (response.data != null) {
                        $window.open(
                            config.basePath + "/Reports/" + response.data,
                            "_blank"
                        );
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }
            );
        };

        $scope.PrintTempGeneralLedger = function () {
            var displayedData = $("#gl-master-grid")
                .data()
                .kendoGrid.dataSource.view();
            console.log(displayedData);

            var Fromdate = $scope.extractDate($scope.filter.FromDate);
            var ToDate = $scope.extractDate($scope.filter.ToDate);

            var array = [];
            angular.forEach($scope.GlData, function (e) {
                var date = new Date(e.Date);
                date = $scope.extractDate(date);

                var temp = {
                    AccountId: e.AccountId,
                    AccountName: e.Account.Name,
                    Date: date,
                    Voucher: e.VoucherNumber,
                    Type: e.Type,
                    RefAccount: e.RefAccount.Name,
                    Remarks: e.Remarks,
                    Debit: e.Debit,
                    Credit: e.Credit,
                    Balance: e.BalanceAmount,
                    TotalCredit: 0,
                    TotalDebit: 0,
                    TotalBalance: 0,
                    OpeningBalance: 0,
                    LedgerCredit: 0,
                    LedgerDebit: 0,
                    LedgerBalance: $scope.totalBalance,
                    DateFrom: Fromdate,
                    DateTo: ToDate,
                };
                array.push(temp);
            });

            $.LoadingOverlay("show", {
                image: "images/load.gif",
            });

            MainService.PrintTempGeneralLedger(array).then(
                function (response) {
                    if (response.data != null) {
                        $window.open(
                            config.basePath + "/Reports/" + response.data,
                            "_blank"
                        );
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }
            );
        };

        //        $scope.GLData = {};
        //        $scope.VoucherData = {};
        //        $scope.GetVoucherDetailsInGL = function () {
        //
        //            $scope.VoucherData = {};
        //
        //            grid = $("#gl-master-grid").data("kendoGrid");
        //            $scope.GLData = grid.dataItem(grid.select());
        //
        //            alert("123");
        //
        //        }

        //        $scope.RecalculateAllAccounts = function () {
        //
        //            $scope.AccLoad = true;
        //            MainService.RecalculateAllAccounts().then(function (response) {
        //                    if (response.data) {
        //                        toastr.success("Success");
        //                    } else {
        //                        toastr.error("Network Error");
        //                    }
        //                    $scope.AccLoad = false;
        //                },
        //                function (err) {
        //                    $scope.AccLoad = false;
        //                    toastr.error("Network Error");
        //                });
        //
        //        }
        //
        //        $scope.RecalculateAccountById = function (data) {
        //            console.log(data)
        //
        //            $scope.AccLoad = true;
        //            MainService.RecalculateAccountById(data.items[0].AccountId).then(function (response) {
        //                    if (response.data) {
        //                        toastr.success("Success");
        //                    } else {
        //                        toastr.error("Network Error");
        //                    }
        //                    $scope.AccLoad = false;
        //                },
        //                function (err) {
        //                    $scope.AccLoad = false;
        //                    toastr.error("Network Error");
        //                });
        //
        //        }

        $scope.goLegerVoucher = function (selectedData) {
            console.log(selectedData);

            if (selectedData.Type == "Sales Invoice") {
                var url = $state.href("editSalesInvoice", {
                    VoucherId: selectedData.SalesInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Sales Invoice 2") {
                var url = $state.href("editSalesInvoice2", {
                    VoucherId: selectedData.SalesInvoice2Id,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Sales Invoice 3") {
                var url = $state.href("editSalesInvoice3", {
                    VoucherId: selectedData.SalesInvoice3Id,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Sales Invoice 4") {
                var url = $state.href("editSalesInvoice4", {
                    VoucherId: selectedData.SalesInvoice4Id,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Sales Return") {
                var url = $state.href("editSalesReturn", {
                    VoucherId: selectedData.SalesReturnId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Credit Note SR") {
                var url = $state.href("editCreditNoteSR", {
                    VoucherId: selectedData.CreditNoteSRId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Purchase Invoice") {
                var url = $state.href("editPurchaseInvoice", {
                    VoucherId: selectedData.PurchaseInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Purchase Return") {
                var url = $state.href("editPurchaseReturn", {
                    VoucherId: selectedData.PurchaseReturnId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Opening Balance") {
                var url = $state.href("editOpeningBalance", {
                    VoucherId: selectedData.OpeningBalanceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Fund Payment Voucher") {
                var url = $state.href("editFPVMaster", {
                    VoucherId: selectedData.FPVId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Fund Receipt Voucher") {
                var url = $state.href("editFRVMaster", {
                    VoucherId: selectedData.FRVId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Cash Payment Voucher") {
                var url = $state.href("editCPVMaster", {
                    VoucherId: selectedData.CPVId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Cash Receipt Voucher") {
                var url = $state.href("editCRVMaster", {
                    VoucherId: selectedData.CRVId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Cheque Payment Voucher") {
                var url = $state.href("editChequePVMaster", {
                    VoucherId: selectedData.ChequePaymentId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Cheque Receipt Voucher") {
                var url = $state.href("editChequeRVMaster", {
                    VoucherId: selectedData.ChequeReceiptId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Journal Voucher") {
                var url = $state.href("editJVMaster", {
                    VoucherId: selectedData.JVId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "PDC") {
                //                var url = $state.href('editFRVMaster', {
                //                    VoucherId: selectedData.FRVId
                //                });
                //                $window.open(url, '_blank');
                //
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.PDCId
                //                })
            } else if (selectedData.Type == "Company Expense") {
                var url = $state.href("editcompanyExpense", {
                    VoucherId: selectedData.CompanyExpenseId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Counter Sales") {
                var url = $state.href("counterSalesEdit", {
                    VoucherId: selectedData.CounterSalesId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Counter Sales") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.
                //                })
            }
            //            if (selectedData.Type == "Contract Invoice") {
            //                $state.go("editPurchaseInvoice", {
            //                    VoucherId: selectedData.
            //                })
            //            }
            else if (selectedData.Type == "Direct Sales Invoice") {
                var url = $state.href("editDirSalesInvoice", {
                    VoucherId: selectedData.DirSalesInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Direct Purchase Invoice") {
                var url = $state.href("editDirPurchaseInvoice", {
                    VoucherId: selectedData.DirPurchaseInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Export Sales Invoice") {
                var url = $state.href("editExpSalesInvoice", {
                    VoucherId: selectedData.ExpSalesInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Export Purchase Invoice") {
                var url = $state.href("editExpPurchaseInvoice", {
                    VoucherId: selectedData.ExpPurchaseInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Import Purchase Invoice") {
                var url = $state.href("editImpPurchaseInvoice", {
                    VoucherId: selectedData.ImpPurchaseInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Opening Stock") {
                var url = $state.href("editOpeningStock", {
                    VoucherId: selectedData.OpeningStockId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Stock Issue") {
                var url = $state.href("editStockIssue", {
                    VoucherId: selectedData.StockIssueId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Stock FOC") {
                var url = $state.href("editStockFOC", {
                    VoucherId: selectedData.StockFOCId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Stock Receive") {
                var url = $state.href("editStockRecieve", {
                    VoucherId: selectedData.StockReceiveId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Credit Note") {
                var url = $state.href("editCreditNote", {
                    VoucherId: selectedData.CreditNoteId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Debit Note") {
                var url = $state.href("editDebitNote", {
                    VoucherId: selectedData.DebitNoteId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Stock JV") {
                var url = $state.href("editStockJV", {
                    VoucherId: selectedData.StockJVId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Individual Sales Invoice") {
                var url = $state.href("editIndSalesInvoice", {
                    VoucherId: selectedData.IndSalesInvoiceId,
                });
                $window.open(url, "_blank");
            } else if (selectedData.Type == "Individual Purchase Invoice") {
                var url = $state.href("editIndPurchaseInvoice", {
                    VoucherId: selectedData.IndPurchaseInvoiceId,
                });
                $window.open(url, "_blank");
            }
        };
  },
]);
